import { render, staticRenderFns } from "./discharge_finding_files.vue?vue&type=template&id=4567919e"
import script from "./discharge_finding_files.vue?vue&type=script&lang=js"
export * from "./discharge_finding_files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports